import React from 'react';
import { Link } from '../../../../ui';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { ICoordinates } from '../../domain/booking/models/ICoordinates';

interface IBookingMapLinkProps {
	coordinates: ICoordinates;
	description: string;
}

export const BookingMapLink = ({
	coordinates,
	description,
}: IBookingMapLinkProps) => {
	const { t } = useTranslation();

	const { latitude, longitude } = coordinates;
	const href = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;

	return (
		<Link
			screenReaderTitle={t('parking_booking_details_view_on_map_sr', {
				name: description,
			})}
			href={href}
			target="_blank"
			rel="noopener"
		>
			{t('parking_booking_details_view_on_map')}
		</Link>
	);
};
